export class UploadFieldRequest {

    configKey: string;

    javascriptContext?: string;

    // Problem: die Map<string, any> wird nicht serialisert
    // wahrscheinlich muss mann sie vor der Übergabe an den backendService
    // mittels JSON.stingify serialisieren
    contextObject?: Map<string, any>;

}
